<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    style="cursor: pointer"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :height="props.size"
      :width="props.size" 
      :fill="props.fillColor" 
      class="material-design-icon__svg" 
      viewBox="0 0 24 24" 
      xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
        fill="#4A4A4A"/>
    </svg>
    
  </span>
</template>

<script>
export default {
  name: "CopyContent",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/CopyContent.vue